import { usePageSeo } from '../utils/seo';

export default function NotFound() {
  usePageSeo({
    title: 'Страница не найдена | Promokod.online',
    description: 'Страница не найдена или недоступна в текущей публичной версии сайта Promokod.online.',
    noIndex: true,
  });

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-gray-50">
      <h1 className="text-6xl font-semibold text-gray-200">404</h1>
      <h2 className="text-2xl md:text-3xl font-semibold mt-6 text-gray-900">
        Страница не найдена
      </h2>
      <p className="mt-4 text-base md:text-lg text-gray-500 max-w-md">
        Возможно, страница была удалена, перемещена или недоступна в текущей публичной версии сайта.
      </p>
      <a
        href="/"
        className="mt-8 inline-flex items-center rounded-lg bg-blue-600 px-5 py-3 text-white hover:bg-blue-700 transition-colors"
      >
        Вернуться на главную
      </a>
    </div>
  );
}
